import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal pt-[80px] pb-[40px] px-6 text-white" data-id="element-60">
      <div className="max-w-[1200px] mx-auto" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-62">
          {/* Col 1: Brand */}
          <div data-id="element-63">
            <div className="text-[48px] font-optima mb-2" data-id="element-64">GLENLOFTY</div>
            <div className="text-[14px] font-light uppercase tracking-widest opacity-70" data-id="element-65">
              Pyrenees, Victoria
            </div>
          </div>

          {/* Col 2: Explore */}
          <div data-id="element-66">
            <h4 className="text-[14px] font-semibold uppercase tracking-widest mb-6" data-id="element-67">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-68">
              {['About', 'Wines', 'Sustainability', 'Contact'].map(item => <li key={item} data-id="element-69">
                  <a href="#" className="text-[16px] opacity-80 hover:opacity-100 hover:text-gold transition-colors" data-id="element-70">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Ranges */}
          <div data-id="element-71">
            <h4 className="text-[14px] font-semibold uppercase tracking-widest mb-6" data-id="element-72">
              Wine Ranges
            </h4>
            <ul className="space-y-4" data-id="element-73">
              {['GO Range', 'Estate Reserve', 'Single Block'].map(item => <li key={item} data-id="element-74">
                  <a href="#" className="text-[16px] opacity-80 hover:opacity-100 hover:text-gold transition-colors" data-id="element-75">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 4: Connect */}
          <div data-id="element-76">
            <h4 className="text-[14px] font-semibold uppercase tracking-widest mb-6" data-id="element-77">
              Connect
            </h4>
            <div className="space-y-4 text-[16px] opacity-80" data-id="element-78">
              <p data-id="element-79">
                123 Glenlofty-Warrenmang Road,
                <br data-id="element-80" />
                Glenlofty, VIC 3469
              </p>
              <p data-id="element-81">(03) 5354 8228</p>
              <p data-id="element-82">
                <a href="mailto:hello@glenloftywines.com.au" className="hover:text-gold" data-id="element-83">
                  hello@glenloftywines.com.au
                </a>
              </p>
              <div className="flex space-x-4 pt-2" data-id="element-84">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-85">
                  <Instagram className="w-6 h-6" data-id="element-86" />
                </a>
                <a href="#" className="hover:text-gold transition-colors" data-id="element-87">
                  <Facebook className="w-6 h-6" data-id="element-88" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[14px] opacity-60" data-id="element-89">
          <div className="flex gap-6" data-id="element-90">
            <a href="#" className="hover:text-white" data-id="element-91">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-92">
              Terms & Conditions
            </a>
          </div>
          <div data-id="element-93">© 2026 Glenlofty Estate. All rights reserved.</div>
        </div>

        {/* Legal Warning */}
        <div className="mt-8 text-center text-[12px] font-light opacity-50 max-w-[900px] mx-auto border-t border-white/10 pt-4" data-id="element-94">
          It is an offence to sell or supply alcohol to, or to obtain alcohol on
          behalf of, a person under the age of 18 years.
        </div>
      </div>
    </footer>;
}